/* 4ThePark cart drawer (sections/tp-cart-drawer.liquid).
   - window.tpCart.add(items) posts to /cart/add.js, re-renders the drawer from the
     response's `sections` and opens it (used by the product form, always: merchant).
   - The header cart icon opens the drawer instead of going to /cart (the link still
     works with JS off).
   - +/- / Remove use /cart/change.js; upsell and best-seller cards add in place.
   Everything re-renders server-side (Section Rendering API), so prices, discounts and
   the bundle offer bar always match Shopify. */
(function () {
  if (window.tpCart) return;
  var SECTION = 'tp-cart-drawer';

  function dialog() { return document.getElementById('TpCartDrawer'); }
  function content() { var d = dialog(); return d && d.querySelector('[data-tp-cd-content]'); }

  function setCount(n) {
    document.querySelectorAll('.tp-header__icon[href$="/cart"]').forEach(function (a) {
      var badge = a.querySelector('.tp-header__count');
      if (n > 0) {
        if (!badge) { badge = document.createElement('span'); badge.className = 'tp-header__count'; a.appendChild(badge); }
        badge.textContent = n;
      } else if (badge) {
        badge.remove();
      }
      a.setAttribute('aria-label', 'Cart, ' + n + ' items');
    });
  }

  function render(html) {
    if (!html) return;
    var fresh = new DOMParser().parseFromString(html, 'text/html').querySelector('[data-tp-cd-content]');
    var cur = content();
    if (fresh && cur) cur.replaceWith(fresh);
  }

  function busy(on) { var c = content(); if (c) c.classList.toggle('is-busy', on); }

  function showError(msg) {
    var el = dialog() && dialog().querySelector('[data-tp-cd-error]');
    if (el) { el.textContent = msg; el.hidden = !msg; }
  }

  function open() {
    var d = dialog();
    if (!d) { window.location.href = '/cart'; return; }
    if (!d.open) { d.showModal(); document.documentElement.classList.add('tp-cd-lock'); }
  }

  function close() {
    var d = dialog();
    if (d && d.open) d.close();
  }

  function json(r) {
    return r.json().then(function (j) {
      if (!r.ok) throw new Error(j.description || j.message || 'Something went wrong. Please try again.');
      return j;
    });
  }

  function refresh() {
    return fetch(window.location.pathname + '?sections=' + SECTION, { headers: { Accept: 'application/json' } })
      .then(function (r) { return r.json(); })
      .then(function (j) { render(j[SECTION]); return fetch('/cart.js').then(function (r) { return r.json(); }); })
      .then(function (c) { setCount(c.item_count); return c; });
  }

  function post(url, body) {
    body.sections = SECTION;
    body.sections_url = window.location.pathname;
    return fetch(url, { method: 'POST', headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body) }).then(json);
  }

  function after(j) {
    if (j.sections) render(j.sections[SECTION]);
    return fetch('/cart.js').then(function (r) { return r.json(); }).then(function (c) { setCount(c.item_count); return c; });
  }

  /* Add items ([{id, quantity}]) and open the drawer. Rejects with the Shopify message. */
  function add(items) {
    return post('/cart/add.js', { items: items }).then(after).then(function (c) { open(); return c; });
  }

  function change(key, qty) {
    busy(true); showError('');
    return post('/cart/change.js', { id: key, quantity: qty }).then(after)
      .catch(function (e) { showError(e.message); })
      .then(function () { busy(false); });
  }

  document.addEventListener('click', function (e) {
    var icon = e.target.closest('.tp-header__icon[href$="/cart"]');
    if (icon && !e.metaKey && !e.ctrlKey && !e.shiftKey) {
      e.preventDefault();
      open();
      refresh();
      return;
    }
    var d = dialog();
    if (!d || !d.contains(e.target)) return;
    if (e.target === d || e.target.closest('[data-tp-cd-close]')) { close(); return; }
    var q = e.target.closest('[data-tp-cd-qty]');
    if (q) {
      var line = q.closest('[data-key]');
      if (line) change(line.getAttribute('data-key'), Number(q.getAttribute('data-tp-cd-qty')));
    }
  });

  document.addEventListener('submit', function (e) {
    var form = e.target.closest && e.target.closest('[data-tp-cd-add]');
    if (!form) return;
    e.preventDefault();
    var btn = form.querySelector('button[type="submit"]');
    if (btn) { btn.disabled = true; btn.textContent = 'Adding…'; }
    busy(true); showError('');
    var inDrawer = !!(dialog() && dialog().contains(form));
    post('/cart/add.js', { items: [{ id: Number(new FormData(form).get('id')), quantity: 1 }] })
      .then(after)
      .then(function () {
        // Cards outside the drawer (product page "More from <park>") open it after adding.
        if (!inDrawer) { open(); if (btn) { btn.disabled = false; btn.textContent = '+ Add'; } }
      })
      .catch(function (err) {
        showError(err.message);
        if (btn) { btn.disabled = false; btn.textContent = '+ Add'; }
      })
      .then(function () { busy(false); });
  });

  document.addEventListener('close', function (e) {
    if (e.target === dialog()) document.documentElement.classList.remove('tp-cd-lock');
  }, true);

  window.tpCart = { open: open, close: close, add: add, refresh: refresh };
})();
